export const RESET = 'EXSBOPERATION_UPDATE_RESET'
export const SET_ERROR = 'EXSBOPERATION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBOPERATION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBOPERATION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBOPERATION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBOPERATION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBOPERATION_UPDATE_UPDATE_RETRIEVED'
